import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as OfferApiDetailPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api";
import { Route as OfferFormDetailPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form";
import { Route as OfferLinkDetailPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/")({
    component: OfferDetailPage,
    staticData: {
        permissions: [PermissionEnum.OfferApiView, PermissionEnum.OfferIframeView, PermissionEnum.OfferLinkView],
        showInSideMenu: false,
        label: "pages.offer.detail.title",
        redirects: [OfferApiDetailPage, OfferLinkDetailPage, OfferFormDetailPage],
        defaultRedirect: OfferFormDetailPage,
    },
});
function OfferDetailPage() {
    return <RedirectPage />;
}
